"use client";
import PageLayout from "@/layouts/pageLayout";
import Hero from "./components/hero";
import IntroComponent from "./components/intro";
import PricingLayout from "./components/layout";
import BaremetalTable from "./components/tables/baremetal";
import OrganizationServerPricing from "./components/tables/vdi/organizationServers";
import VmPersonalPricing from "./components/tables/vdi/vmPersonal";
import GpuTables from "./components/tables/gpuTables";
import M365Table from "./components/tables/m365";
import IntelDedicatedPricing from "./components/tables/cloudVm/intelDedicated";
import AmdDedicatedPricing from "./components/tables/cloudVm/amdDedicated";
import SharedIntelPricing from "./components/tables/cloudVm/sharedIntel";
import ISVDesktopTable from "./components/tables/isvDektops";
import IpPricingTable from "./components/tables/ipv4-v6";
import KubernetesPricingTable from "./components/tables/kubernetes";
import PaasPricingTables from "./components/tables/paas";
import ColocationPricing from "./components/tables/colocation";
import PerformanceStorageTable from "./components/tables/performanceObjectStorage";
import BlockStorageTable from "./components/tables/blockStorage";

const PricingPage = () => {
  return (
    <>
      <Hero />
      <PageLayout showContactForm marginTop={0}>
        <IntroComponent />
        <PricingLayout>
          <BaremetalTable />
          <IntelDedicatedPricing />
          <AmdDedicatedPricing />
          <SharedIntelPricing />
          <GpuTables />
          <M365Table />
          <OrganizationServerPricing />
          <VmPersonalPricing />
          <ISVDesktopTable />
          <IpPricingTable />
          <KubernetesPricingTable />
          <PaasPricingTables />
          <ColocationPricing />
          <PerformanceStorageTable />
          <BlockStorageTable />
        </PricingLayout>
      </PageLayout>
    </>
  );
};

export default PricingPage;
